import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {allCmsSpecialtiesDropdown} from "../../../relay/Fragments";
import {createOptions} from "../../../helpers/utils";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewFacilityLocationCmsSpecialtyModal = ({showModal, onClose, facilityLocationId, cmsSpecialties}) => {
    const mutation = graphql`
    mutation NewFacilityLocationCmsSpecialtyModalMutation($facilityLocationId: ID!, $cmsSpecialtyId: ID!, $numberOfBeds: Int, $effectiveFrom: DateOnly!,
    $effectiveTo:DateOnly!) {
        facilityLocation {
            createCmsSpecialty(input: {facilityLocationId: $facilityLocationId, cmsSpecialtyId: $cmsSpecialtyId, numberOfBeds: $numberOfBeds, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityLocationCmsSpecialty {
                    id
                    facilityLocation {
                        cmsSpecialties {
                            ...FacilityLocationCmsSpecialties_CmsSpecialties
                        }}}}}}`
    const cmsSpecialtiesData = useFragment(allCmsSpecialtiesDropdown, cmsSpecialties).filter(x => x.applicableVersion.appliesToFacilities);
    const cmsSpecialtyOptions = createOptions(
        cmsSpecialtiesData,
        'id',
        'applicableVersion.name'
    );
    const [commitMutation, isInFlight] =  useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityLocationId: facilityLocationId,
        cmsSpecialtyId: '',
        numberOfBeds: null,
    }
    const schema = bandedSchema.shape({
        cmsSpecialtyId: yup.string().required("CMS Specialty is required"),
        numberOfBeds: yup.number()
            .when('cmsSpecialtyId', {
                is: (val) => cmsSpecialtiesData.some(x => x.id === val && x.applicableVersion.requiresBedCount), 
                then: (schema) => schema.required("Number of beds is required for this specialty"),
                otherwise: (schema) => schema.nullable(),
            })
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facilityLocation) {
                    toast.success("CMS Specialty for Facility Location created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New CMS Specialty"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={cmsSpecialtyOptions} controlId={"cmsSpecialtyId"} label={"CMS Specialty"} />
            <HorizontalFormInput controlId={"numberOfBeds"} label={"Number of Beds"} type={"number"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewFacilityLocationCmsSpecialtyModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    facilityLocationId: PropTypes.string.isRequired,
    cmsSpecialties: PropTypes.array.isRequired,
}
export default NewFacilityLocationCmsSpecialtyModal